import { useEffect } from 'react';
import DebounceHelper from '@fec/frontend/foundation/client/debounce-helper';

// wait a little before deciding the scroll direction
const SCROLL_GRACE = 5;

const useScrollDirection = ({
  onScrollUp = () => {},
  onScrollDown = () => {},
  enabled = true,
}) => {
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      if (!enabled) {
        return;
      }

      const scrollY = window.scrollY;
      if (scrollY > lastScrollY + SCROLL_GRACE) {
        onScrollDown();
      } else if (scrollY < lastScrollY - SCROLL_GRACE) {
        onScrollUp();
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    const throttledScrollHandler = DebounceHelper.throttle(handleScroll, 200);
    window.addEventListener('scroll', throttledScrollHandler);

    return () => {
      window.removeEventListener('scroll', throttledScrollHandler);
    };
  }, [onScrollUp, onScrollDown]);
};

export default useScrollDirection;
